import React from 'react';
import loadable from '@loadable/component';
import requireLoggedInSaga from 'routes/helpers/requireLoggedIn';

const WelcomeContainer = loadable(() => import('./WelcomeContainer'));

export default store => ({
  path: 'welcome',

  onEnter: (nextState, replaceState, cb) =>
    store
      .runSagaOnce(requireLoggedInSaga, nextState, replaceState)
      .toPromise()
      .then(cb, cb),

  indexRoute: {
    component: props => <WelcomeContainer {...props} />,
  },
  childRoutes: [{ path: '*', component: props => <WelcomeContainer {...props} /> }],
});
